export enum GraphLayoutDirection {
    TopToBottom = "TB",
    BottomToTop = "BT",
    LeftToRight = "LR",
    RightToLeft = "RL"
}

export enum GraphLayoutAlignment {
    UpperLeft = "UL",
    UpperRight = "UR",
    LowerLeft = "DL",
    LowerRight = "DR"
}

export enum NodeType {
    START = "START",
    END = "END",
    TASK = "TASK",
  }